import _ from 'lodash'
import numeral from 'numeral'
import { getSymbolFromCurrency } from 'currency-symbol-map'

const transformKeys = (obj, transform) => {
  if (_.isPlainObject(obj)) {
    const copy = {}
    Object.keys(obj).forEach((key) => {
      copy[transform.call(undefined, key)] = transformKeys(obj[key], transform)
    })
    return copy
  } else if (_.isArray(obj)) {
    return obj.map(val => (_.isObject(val) ? transformKeys(val, transform) : val))
  }
  return obj
}

export const camelizeKeys = (obj) => transformKeys(obj, _.camelCase)
export const snakelizeKeys = (obj) => transformKeys(obj, _.snakeCase)

export const currencySymbol = currencyCode => getSymbolFromCurrency(currencyCode)

export const formatPriceDecimals = (price, currencyCode) =>
  (!_.isNil(price) ? `${currencyCode ? currencySymbol(currencyCode) : ''}${numeral(price).format('0,0.00')}` : '--')

export const formatHourMinute = (hour, minute) =>
  `${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute}`



/** WEBPACK FOOTER **
 ** ./src/utils/format/format.js
 **/